import api from "../axios";

export async function getCareManagerOverviewKpis(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/care-manager-overview/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}

export async function getCareManagerPerformance(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/care-manager-performance/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}
